import styled from 'styled-components';

import AutocompleteAddressInput from 'components/autocomplete-address-input';

import theme from '../theme';

export const SearchBarWrapper = styled.div<{ isListView?: boolean; smallSize?: boolean }>`
  margin: 1rem auto;
  width: ${p => (p.smallSize ? 'calc(100% - 8rem)' : 'calc(100% - 2rem)')};
  border-radius: ${Styles.borderRadius};
  display: flex;
  height: 3rem;
  position: ${p => (p.isListView ? 'relative' : 'absolute')};
  left: ${p => (p.isListView ? '0' : '1rem')};
  z-index: ${Styles.zIndex.top};
  ${Styles.desktop`
    left: 0;
    margin: 0 auto;
    position: relative;
    z-index: auto;
    width: 100%;
  `}
`;

export const SearchBarBoxShadow = styled.div`
  /* wraps input and toggle and provides box shadow */
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  display: flex;
  width: 100%;
  z-index: ${Styles.zIndex.below};
`;

export const SearchInput = styled(AutocompleteAddressInput)`
  margin: 0;
`;

export const Button = styled.button`
  /* @TODO the theme should be set in the Input Component */
  background: ${theme.clearButtonBackgroundColor};
  border: none;
  border-radius: 0 ${Styles.borderRadius} ${Styles.borderRadius} 0;
  cursor: pointer;
  height: 3rem;
  min-width: 3rem;
  position: absolute;
  right: 1px;
  top: 1px;
  width: 3rem;
  z-index: ${Styles.zIndex.below}; /* fixes shadow bug */

  svg {
    fill: ${Styles.color.grey.one};
    width: 1.25rem;
  }
`;
